import { connect } from 'react-redux'
import { Component } from "react"
import { v4 as uuidv4 } from 'uuid';
import {
    ActionIcon,
    Alert,
    Avatar,
    Collapse,
    Tooltip,
    Group,
    Loader,
    Menu,
    Stack,
    Text,
    Flex,
    CloseButton,
    Badge,
    Tabs
} from "@mantine/core";
import { IconCaretDownFilled, IconDots, IconXboxX} from '@tabler/icons-react';
import ChatMessage from "./ChatMessage.jsx"
import ChatDialog from "./ChatDialog.jsx"
import {onUserActionOpenCloseChatPrivate} from "../../actions"
import{__, Capitalize} from "../../traslates/blabla"

import {createXMPPConnexion, getVcardAsync} from '../../game/jabber.jsx'

const pathContext = {
    user: undefined,
    xmpp: null,
    getVcard: null,
    xml: null,
    users: {},
    message_id:{},
    message_displayed:{},
    messages: [],
    current_tab: "monde",
    users_messages: {},
    xmppParams:{},
    current_user_dialog:null,
    rooms: {"monde": []},
    version: 0
}

let xmpp_init = false
let timerLoadingAvatar
class ChatWidget extends Component{

    constructor(props) {
        super(props)
        this.state = pathContext
        this.state.user = JSON.parse(JSON.stringify(props.user))
        //this.state.user.avatar = default_avatar
        
        
    }

    makeStateCopy(){
        return {
            user: this.state.user,
            messages: this.state.messages,
            message_id: this.state.message_id,
            message_displayed: this.state.message_displayed,
            users_messages: this.state.users_messages,
            users: this.state.users,
            rooms: this.state.rooms,
            current_tab: this.state.current_tab,
            is_mini: this.state.is_mini,
            xmpp: this.state.xmpp,
            xml: this.state.xml,
            current_user_dialog: this.state.current_user_dialog,
            xmppParams: this.state.xmppParams,
            getVcard: this.state.getVcard,
            version: this.state.version + 1
        }
    }

    async componentDidMount() {
        if(this.props.user && this.props.user.chat_rooms){
            const state = this.makeStateCopy()
            for(let i=0; i < this.props.user.chat_rooms.length; i ++){
                state.rooms[this.props.user.chat_rooms[i]] = []
            }
            this.setState(state)
        }

        

        this.state.xmppParams = {
            onPresence:(from, online)=>{
                const state = this.makeStateCopy()
                if(state.users[from]){
                    state.users[from].online = online
                    
                } else{
                    let user = {
                        email: from,
                        pseudo: from.split("@")[0],
                        online: online
                    }
                    state.users[from] = user
                }

                
                this.setState(state)
            },
            onUserMessage: async (from, to, message, id, at, timestamp, is_new, getVcard) =>{
                const state = this.makeStateCopy()

                if( state.message_id[id]) return
                let pseudo =  to.split("@")[0].toLowerCase()
                let thread = to
                if(pseudo === this.props.user.pseudo.toLowerCase()){ 
                    thread = from
                }

                

                let user = {
                    email: from,
                    pseudo: from.split("@")[0]
                }

                let user_to = {
                    email: to,
                    pseudo: to.split("@")[0]
                }

                if(from === this.props.user.email){ 
                    user = user = this.state.user//JSON.parse(JSON.stringify(this.props.user))
                }

                if(state.users[from]){
                    user = state.users[from]
                } else {
                    //user.avatar = default_avatar
                    state.users[from] = user
                    //if(state.getVcard) state.getVcard(from)
                    
                }

                if(state.users[to]){
                    user_to = state.users[to]
                } else {
                    //user.avatar = default_avatar
                    state.users[to] = user_to
                    //if(state.getVcard) state.getVcard(to)
                }

                
                state.users[from].canloadAvatar = true
                const msg = {
                    id: id,
                    from: user,
                    to: to,
                    text: message,
                    vue: state.message_displayed[id] ? true : false,
                    at: at,
                    timestamp: timestamp,
                    position: from === this.props.user.email? "right": "left"
                }
                if(!state.users_messages[thread]){
                    state.users_messages[thread] = {thread:thread, message: [], timestamp: "0000-00-00T00:00:00"}
                    state.messages.push(state.users_messages[thread])
                }
                else {
                    if(!state.users_messages[thread].message) state.users_messages[thread].message = []
                    
                }

                
                state.users_messages[thread].message.push(msg)
                state.users_messages[thread].timestamp = timestamp

                state.message_id[id]=msg

                state.messages.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
                this.setState(state)
            },
            onRoomMessage: (from, room, message, id, at, timestamp, is_new, getVcard) =>{
                const state = this.makeStateCopy()

                if( state.message_id[id]) return

                const jid = from
                let user = {
                    email: from,
                    pseudo: from.split("@")[0]
                }

                if(from === this.props.user.email){ 
                    user = this.state.user//JSON.parse(JSON.stringify(this.props.user))
                    this.setLastRead(room, timestamp);
                    this.applyReadUpTo(room, timestamp, true);
                }

                if(state.users[from]){
                    user = state.users[from]
                } else {
                    //user.avatar = default_avatar
                    state.users[from] = user
                    //getVcard(from)
                }

                state.users[from].canloadAvatar = true
                const msg = {
                    id: id,
                    from: user,
                    text: message,
                    vue: state.message_displayed[id] ? true : false,
                    at: at,
                    timestamp: timestamp,
                    position: from === this.props.user.email? "right": "left"
                }

                if(!state.rooms[room]){
                    state.rooms[room] = []
                }

                state.message_id[id]=msg
                
                state.rooms[room].push(msg)
                this.setState(state)
            },
            onMessageDisplayed: (id)=>{
                const state = this.makeStateCopy()
                
                state.message_displayed[id] = true
                if(state.message_id[id]){
                    state.message_id[id].vue = true
                    this.setState(state)
                }
            },
            onUserAvatar: (from, avatar)=>{
                const state = this.makeStateCopy()
                

                if(from === this.props.user.email){ 
                    state.user.avatar = avatar
                }
                if(state.users[from]) state.users[from].avatar = avatar
                state.users[from].version = state.users[from].version ? 1: state.users[from].version +1 

                this.setState(state)
            },
            onGetVcardReady: (getVcard)=>{
                const state = this.makeStateCopy()
                state.getVcard = getVcard
                this.setState(state)

                
            },
            onXMPPREady:  (xmpp, xml)=>{
                const state = this.makeStateCopy()
                state.xmpp = xmpp
                state.xml = xml
                this.setState(state)
                
               
            },
            onOnLine:  (xmpp, jid)=>{
                setTimeout(async ()=>{
                    const avatar =await getVcardAsync(xmpp, jid)
                    const state = this.makeStateCopy()
                    state.user.avatar = avatar
                    this.setState(state)
                }, 10)
            }
        }

        if(!xmpp_init && this.props.user){
            createXMPPConnexion(this.props.user, this.state.xmppParams, this.state.notification)
            
        }
        
        this.props.notification.addNotification("onChatDialog", async (type, msg, arg)=>{

            const jid = `${msg.pseudo.toLowerCase()}@ifrit.fr`
            const state = this.makeStateCopy()
            state.current_user_dialog = {
                "thread": msg
            }
            if(!state.users_messages){
                state.users_messages = {}
            }

            if(!state.users_messages[jid]){
                state.users_messages[jid] = {thread:jid, message: [], timestamp: "0000-00-00T00:00:00"}
                state.messages.push(state.users_messages[jid])
            }

            state.current_user_dialog.messages = this.state.users_messages[jid].message
            state.current_tab = "private"
            setTimeout(()=>{
                this.setState(state)
            }, 400 )
            
            this.props.onUserActionOpenCloseChatPrivate(this.props.openCloseChatPrivate === "close" ? "open":"close")
            
        })
        this.props.notification.addNotification("UserAvatar", async (type, msg, arg)=>{
            console.log("getUserAvatar", msg, this.state.users)

            const from = msg.pseudo.toLowerCase() + "@ifrit.fr"
            const state = this.makeStateCopy()
            if(state.users[from]){ 
                if(!state.users[from].avatar){ 
                    state.users[from].canloadAvatar = true
                    this.setState(state)
                } else {
                    this.props.notification.onNotification("UserAvatarReady", msg, state.users[from].avatar)
                }
            }
            else {
                
            }
            

            /*if(msg.pseudo && this.state.getVcard){
                const from = msg.pseudo.toLowerCase() + "@ifrit.fr"
                const state = this.makeStateCopy()
                if(state.users[from] && state.users[from].avatar){
                    this.props.notification.onNotification("UserAvatarReady", msg, state.users[from].avatar)
                    this.setState(state)
                    return
                }
                this.state.getVcard(this.state.xmpp, msg.pseudo.toLowerCase() + "@ifrit.fr", (avatar)=>{
                    if(avatar){
                        
                        
                        if(msg.pseudo === this.props.user.pseudo){ 
                            state.user.avatar = avatar
                        }
                        if(state.users[from]){ 
                            state.users[from].avatar = avatar
                            state.users[from].version = state.users[from].version ? 1: state.users[from].version +1 
                            this.setState(state)
                        }

                        this.props.notification.onNotification("UserAvatarReady", msg, avatar)
                    }
                    console.log("getUserAvatar", msg, avatar)
                })
            }*/
        })
    }
    async loadAvatars(){
        if(!timerLoadingAvatar){ 
            timerLoadingAvatar =setInterval(async()=>{
                const state = this.makeStateCopy();
                let from
                
                if(state.xmpp){ 
                    for(let jid in state.users){
                        if(!state.users[jid].avatar && state.users[jid].canloadAvatar && !state.users[jid].done){
                            
                            from = jid
                            break;
                        }

                    }

                    const avatar =await getVcardAsync(state.xmpp, from)
                    clearInterval(timerLoadingAvatar)
                    timerLoadingAvatar = undefined
                    
                    if(!from){
                        setTimeout(()=>{
                            for(let jid in state.users){
                                if(!state.users[jid].done){
                                    
                                    state.users[jid].done = false
                                }
        
                            }
                            this.loadAvatars()
                        }, 1000*60)
                        return
                    }
                    else {
                        setTimeout(()=>{
                            this.loadAvatars()
                        }, 250)
                    }
                    state.users[from].done = true
                    if(avatar){
                        
                        state.users[from].avatar = avatar
                        this.setState(state)

                        this.props.notification.onNotification("UserAvatarReady", state.users[from], state.users[from].avatar)
                    }
                    
                }

            }, 200)
            
        }
        
    }
    onSendRoomMessage(roomId, msg){
        //console.log("onSendRoomMessage", roomId, msg, this.state.xmpp)
        const id = uuidv4();
        const message = this.state.xml(
            'message',
            { to: roomId + "@conference.ifrit.fr", type: 'groupchat', id: id },
            this.state.xml('body', {}, msg)
        )

        this.state.xmpp.send(message)

    }

    onSendUserMessage(user, text){
        const id = uuidv4();
        const jid = user.pseudo.toLowerCase() + "@ifrit.fr"
        const from = this.state.user.pseudo.toLowerCase() + "@ifrit.fr"
        const message = this.state.xml(
            'message',
            { to: jid, id: id, type: 'chat'},
            this.state.xml('markable', { xmlns: 'urn:xmpp:chat-markers:0' }),
            this.state.xml('body', {}, text)
        )
        this.state.xmpp.send(message)
        const now = new Date().toISOString();
        this.state.xmppParams.onUserMessage(
            from,         // vers qui le message a été envoyé
            jid,
            text,  
            id,
            "à l’instant", // texte pour l’heure relative
            now, // timestamp ISO
            this.state.user.avatar,            // avatar de Nicolas (local)
            true                       // isLive (message en direct)
        )

        this.setLastRead(jid, now);
        this.applyReadUpTo(jid, now, false);
    }

    getLastRead(key){
        try { 
            return localStorage.getItem(`lastRead_${key}`) || null; 
        }
        catch { return null; }
    }
      
    setLastRead = (key, ts) => {
        if (!ts) return;
        try {
            const lastRead = this.getLastRead(key);
            if(!lastRead || ts > lastRead){ 
                localStorage.setItem(`lastRead_${key}`, ts); 
            }
        } 
        catch (e){
            console.log("setLastRead", e)
        }
    }
    applyReadUpTo(key, ts, isRoom = true){
        // Marque en lu tous les messages de la conv avec timestamp <= ts
        const state = this.makeStateCopy();
        const list = isRoom ? (state.rooms[key] || []) :
          ((state.users_messages[key] && state.users_messages[key].message) ? state.users_messages[key].message : []);
      
        if (!list) return;
      
        for (let i = 0; i < list.length; i++) {
          if (!list[i].vue && list[i].timestamp && list[i].timestamp <= ts) {
            list[i].vue = true;
            if (list[i].id) state.message_displayed[list[i].id] = true;
          }
        }
        this.setState(state);
    }

    countUnread = (key, list) => {
        if (!list || list.length === 0) return 0;
        const lastRead = this.getLastRead(key); // string ISO | null
        if (!lastRead) {
          // Jamais lu -> tous non lus
          return list.filter(m => !m.vue).length || list.length;
        }
        let n = 0;
        for (let i = 0; i < list.length; i++) {
          const m = list[i];
          // Non lu si timestamp > lastRead
          if (m.timestamp && m.timestamp > lastRead && !m.vue) n++;
        }
        return n;
    }
      
    updateNBMessageRoomReadStatus(roomId){ 
        const list = this.state.rooms[roomId] || [];
        if (list.length > 0) {
            const lastTs = list[list.length - 1].timestamp;
            const currentTs = this.getLastRead(roomId)
            if(lastTs>currentTs || !currentTs){ 
                this.setLastRead(roomId, lastTs);
                this.applyReadUpTo(roomId, lastTs, true);
            }
        }
    }
    updateNBMessageUserReadStatus(jid){ 
        
        const pm = this.state.users_messages[jid]?.message || [];
        if (pm.length > 0) {
            const lastTs = pm[pm.length - 1].timestamp;
            const currentTs = this.getLastRead(jid)
            if(lastTs>currentTs || !currentTs){ 
                this.setLastRead(jid, lastTs);
                this.applyReadUpTo(jid, lastTs, true);
            }
        }
    }
    render(){


        if(this.props.openCloseChatPrivate === 'open' && this.state.current_tab !== "private"){
            this.updateNBMessageRoomReadStatus(this.state.current_tab)
        }
        else if(this.props.openCloseChatPrivate === 'open' && this.state.current_tab === "private"  && this.state.current_user_dialog){
            this.updateNBMessageUserReadStatus(this.state.current_user_dialog.thread.email)
        }

        let messagesPrivate = null
        let lastMessageUserPrivate = null
        let lastMessagePrivate = null
        try{
            for(let n=this.state.messages.length-1; n>0; n --){ 
                messagesPrivate = this.state.messages[this.state.messages.length-1].message
                lastMessageUserPrivate = this.state.messages[this.state.messages.length-1]
                lastMessagePrivate = JSON.parse(JSON.stringify(messagesPrivate[messagesPrivate.length - 1]))
                if(lastMessagePrivate) break
            }
        }catch(e){

        }
        let lastMessageRoom = {}
        try{
            for(let r in this.state.rooms){
                const m = this.state.rooms[r]
                if(m && m.length > 0){
                    lastMessageRoom[r] = m[m.length - 1]
                }
            }
        }catch(e){
        }

        let new_room_messages = {
        }

        for(let r in this.state.rooms){
            const m = this.state.rooms[r] || [];
            new_room_messages[r] = this.countUnread(r, m);
        }

        let new_private_total = 0;
        for (let jid in this.state.users_messages) {
            const m = this.state.users_messages[jid]?.message || [];
            new_private_total += this.countUnread(jid, m);
        }


        //console.log("ChatWidget.render new_room_messages", new_room_messages, this.state.current_tab)

        /*if(lastMessageRoom[this.state.current_tab]){
            const xwait = setInterval(()=>{
                if(this.state.xmpp){ 
                    clearInterval(xwait)
                    this.onMessageVue(lastMessageRoom[this.state.current_tab].id, true)
                }
            }, 150)
            
        }*/
       
       this.loadAvatars()
        return (
            <section className='chatwidget'>
                {
                    this.props.openCloseChatPrivate === "open" ? (
                        <ActionIcon className='close' size={20} onClick={(e)=>{
                            this.props.onUserActionOpenCloseChatPrivate("close")
                        }}><IconCaretDownFilled size={10} /></ActionIcon>
                    ):"" 
                }
              <Tabs value={this.state.current_tab}>
                <Tabs.List>
                    {

                        Object.entries(this.state.rooms).map(([roomId, roomData]) => (
                            <Tabs.Tab value={roomId} onClick={(e)=>{
                                const state = this.makeStateCopy(); 
                                state.current_tab=roomId;
                                this.setState(state)}} key={roomId}>
                                {Capitalize(__(roomId))} {new_room_messages[roomId]>0?(<Badge ml="xs" size="sm" variant="filled" color="red">{new_room_messages[roomId]}</Badge>):""}
                                
                            </Tabs.Tab>
                        ))
                    }
                    <Tabs.Tab value="private" onClick={(e)=>{
                        const state = this.makeStateCopy(); 
                        state.current_tab="private" ;
                        this.setState(state)}} key="private">
                        <>
                            {__("ChatPrivate")}
                            {new_private_total > 0 && (
                            <Badge ml="xs" size="sm" variant="filled" color="red">
                                {new_private_total}
                            </Badge>)}
                        </>
                    </Tabs.Tab>
                </Tabs.List>
                {

                    Object.entries(this.state.rooms).map(([roomId, roomData]) => (
                        <Tabs.Panel value={roomId}>
                            <Group className='mini' justify="left">
                                <>
                                    
                                    { 
                                        lastMessageRoom[roomId] && this.props.openCloseChatPrivate === "close" ? ( 
                                            <>
                                                <div className='control' onClick={()=>{
                                                    const state = this.makeStateCopy()
                                                    state.current_tab = roomId
                                                    this.setState(state)
                                                    this.updateNBMessageRoomReadStatus(roomId)
                                                    
                                                    this.props.onUserActionOpenCloseChatPrivate(this.props.openCloseChatPrivate === "close" ? "open":"close")
                                                }}></div>
                                                <ChatMessage message={lastMessageRoom[roomId]} avatar={lastMessageRoom[roomId].from.avatar}/>      
                                                
                                            </>
                                        ): this.props.openCloseChatPrivate !== 'open' ? (
                                            <>
                                                <div className='control' onClick={()=>{
                                                    const state = this.makeStateCopy()
                                                    state.current_tab = roomId
                                                    this.setState(state)
                                                    this.props.onUserActionOpenCloseChatPrivate(this.props.openCloseChatPrivate === "close" ? "open":"close")
                                                }}></div>
                                                <div className='no-message'>{__("Pas de messages")}</div>
                                            </>
                                        ) : ""
                                    }
                                    {
                                        this.props.openCloseChatPrivate === "open" && this.state.current_tab === roomId ? (
                                            <>
                                            <ChatDialog messages={roomData} onSendMessage={(msg)=>this.onSendRoomMessage(roomId, msg)} />
                                            </>
                                        ) : ""
                                    }

                                </>
                            </Group>
                        </Tabs.Panel>
                    ))
                }
                <Tabs.Panel value="private">
                    { 
                        lastMessagePrivate !== null && this.props.openCloseChatPrivate === 'close'? (
                        (
                            <Group className='mini' justify="left">
                                <div className='control' onClick={()=>{
                                    
                                    this.props.onUserActionOpenCloseChatPrivate(this.props.openCloseChatPrivate === "close" ? "open":"close")
                                }}></div>
                                <ChatMessage message={lastMessagePrivate} />
                                { this.countUnread(lastMessageUserPrivate.thread, lastMessageUserPrivate.message) > 0 ? ( 
                                <Badge ml="xs" size="sm" variant="filled" color="red">
                                    {this.countUnread(lastMessageUserPrivate.thread, lastMessageUserPrivate.message)}
                                </Badge>):""}
                            </Group>
                        ) 
                    ): this.props.openCloseChatPrivate !== 'open' ? (<div className='no-message'>{__("Pas de messages")}</div>) : ""}
                    { this.props.openCloseChatPrivate === 'open' && this.state.current_tab === "private" && !this.state.current_user_dialog? (
                        (
                            <Group className='must column' justify="left">
                            {
                                this.state.messages.map((msg, position)=>(
                                    <Group className='mini' justify="left" key={position}>
                                        <div className='control' onClick={()=>{
                                            const jid = msg.thread
                                            const state = this.makeStateCopy()
                                            state.current_user_dialog = {
                                                "thread": state.users[jid]
                                            }

                                            if(!state.users_messages){
                                                state.users_messages = {}
                                            }

                                            if(!state.users_messages[jid]){
                                                state.users_messages[jid] = []
                                            }
                                            else {
                                                //state.users_messages[jid] = state.users_messages[jid]
                                            }
                                            state.current_user_dialog.messages = this.state.users_messages[jid].message
                                            state.current_tab = "private"
                                            this.setState(state)
                                            setTimeout(()=>{
                                                this.updateNBMessageUserReadStatus(jid)
                                            }, 10)
                                            
                                            

                                            //this.props.onUserActionOpenCloseChatPrivate(this.props.openCloseChatPrivate === "close" ? "open":"close")
                                        }}></div>
                                        <ChatMessage message={msg.message[msg.message.length - 1]} />
                                        {this.countUnread(msg.thread, msg.message)>0 ? ( 
                                            <Badge ml="xs" size="sm" variant="filled" color="red">
                                                {this.countUnread(msg.thread, msg.message)}
                                            </Badge>):""}
                                    </Group>

                                ))
                            }
                            </Group>
                        ) 
                    ): ""}
                    { this.props.openCloseChatPrivate === 'open' && this.state.current_tab === "private" && this.state.current_user_dialog? (
                        <Stack className="chatwidget-box" gap={0}>
                            <Stack className='user-dialog-title' justify="center">
                                <Group className='user'gap='xs'>
                                    <Avatar key={this.state.current_user_dialog.thread.pseudo} name={this.state.current_user_dialog.thread.pseudo} color="initials" src={this.state.current_user_dialog.thread.avatar}></Avatar>
                                    <p>{this.state.current_user_dialog.thread.pseudo}</p>
                                </Group>
                                <ActionIcon className='action' size={20} onClick={(e)=>{
                                }}><IconDots size={12} /></ActionIcon>
                                <ActionIcon className='action close' size={20} onClick={(e)=>{
                                    
                                    setTimeout(()=>{
                                        const state = this.makeStateCopy()
                                        state.current_user_dialog = null
                                        state.current_tab = "private"
                                        this.setState(state)
                                        //this.props.onUserActionOpenCloseChatPrivate(this.props.openCloseChatPrivate === "close" ? "open":"close")
                                    }, 100)
                                    
                                }}><IconXboxX size={12} /></ActionIcon>
                            </Stack>
                            <ChatDialog messages={this.state.current_user_dialog.messages} onSendMessage={(msg)=>this.onSendUserMessage(this.state.current_user_dialog.thread, msg)}/>
                        </Stack>
                    ): ""}
                </Tabs.Panel>
              </Tabs> 
            </section>
        )
    }
}



const mapDispatchToProps = {
    onUserActionOpenCloseChatPrivate: onUserActionOpenCloseChatPrivate
}


const mapStateToProps = (state) => {  
    return {
        notification: state ? state.notification : undefined,
        pathSelected: state.pathSelected,
        openCloseChatPrivate: state.openCloseChatPrivate||"close"
    }
}


ChatWidget = connect(mapStateToProps, mapDispatchToProps)(ChatWidget);

export default ChatWidget;